
import "//auriccosmetics.com/cdn/shop/t/62/assets/jquery-3.6.0.min.js?v=115860211936397945481785702571";
import BigPicture from "//auriccosmetics.com/cdn/shop/t/62/assets/BigPicture.min.js?v=94555310030281183341785702571";

$(() => {
  const vids = $('.big-picture-vid video');

  vids.on('click', (e) => {
    e.target.pause();
    const videoSrc = $('source', e.target)[0].src;

    BigPicture({
      // element from which animation starts (required)
      el: e.target,
      // video src (String) or sources (Array)
      vidSrc: videoSrc,
      // show or hide default loading indicator
      noLoader: true,
      // open animation callback
      animationStart: () => {},
      // open animation callback
      animationEnd: () => {},
      // close callback
      onClose: () => {
        e.target.play();
      },
      // gallery image change callback
      onChangeImage: () => {},
    });
  });
});